import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { ScrollingPopup } from 'components/common/popup/popup';
import DistributorList from './distributorList';
import Inputs from 'components/inputs/inputs';
import Panel from 'components/common/panel/panel';
import Helpers from 'utils/helpers';
import useForm from 'hooks/form';

export default function DistributorModal(props) {
  const [filterString, setFilterString] = useState('');
  const [selections, setSelections] = useState([]);
  const [recipientsList, setRecipientsList] = useState([]);
  const [isCreatingRecipient, setIsCreatingRecipient] = useState(false);

  useEffect(() => {
    setSelections(props.recipientsSelected);
    setRecipientsList(props.recipientsList);
  }, [props.recipientsSelected, props.recipientsList]);

  const handleChangeSelection = (newValues) => {
    setSelections(newValues);
  };

  const handleClose = () => {
    if (props.onClose) {
      props.onClose();
    }
  };

  const applyRecipientsClicked = () => {
    props.onChange(selections, recipientsList);
    if (props.onClose) {
      props.onClose();
    }
  };

  const cancelRecipientsClicked = () => {
    if (props.onClose) {
      props.onClose();
    }
  };

  const clearRecipientsClicked = () => {
    setSelections([]);
  };

  const createRecipientSubmitted = async (firstName, lastName, emailAddress) => {
    setIsCreatingRecipient(false);
    if (props.onCreateRecipient) {
      const newRecipientId = await props.onCreateRecipient(firstName, lastName, emailAddress);
      if (newRecipientId) {
        setSelections([...selections, newRecipientId]);
        const newRecipient = { contactName: `${firstName} ${lastName}`, communicationId: newRecipientId, communicationValue: emailAddress };
        const newRecipientsList = Helpers.Array.insertIntoSortedArray(recipientsList, 'contactName', newRecipient);
        setRecipientsList(newRecipientsList);
      }
    }
  };

  const createRecipientClosed = () => {
    setIsCreatingRecipient(false);
  };

  return (
    <ScrollingPopup
      title='Select Recipients'
      show={props.show}
      onClose={handleClose}
      leftIconClass='icons8-add-user-male'
      onLeftIconClick={() => setIsCreatingRecipient(true)}
      header={
        isCreatingRecipient ? null : (
          <Inputs.Text.Throttled
            placeholder='Search'
            value={filterString}
            onValueChange={(value) => setFilterString(value.toLowerCase())}
            isInvalid={filterString.length > 0 && filterString.length < 3}
            debounceDelay={400}
          />
        )
      }
      footer={
        isCreatingRecipient ? null : (
          <div className='d-flex justify-content-between align-items-center w-100'>
            <div>
              <span className='badge badge-success'>{selections.length} Recipients</span>
              <Inputs.Button variant='hover-default' size='sm' className='ml-2' onClick={clearRecipientsClicked} label='Clear' iconClass='icons8-delete' />
            </div>
            <div>
              <Inputs.Button variant='default' onClick={cancelRecipientsClicked} iconClass='icons8-undo' label='Cancel' />
              <Inputs.Button variant='app' onClick={applyRecipientsClicked} iconClass='icons8-checkmark' label='Apply' />
            </ div>
          </div>
        )
      }
    >
      {
        isCreatingRecipient ?
          <CreateRecipientForm onSubmit={createRecipientSubmitted} onClose={createRecipientClosed} />
          :
          <DistributorList recipientsList={recipientsList} filter={filterString} onChange={handleChangeSelection} recipientsSelected={selections} />
      }
    </ScrollingPopup>
  );
}

function CreateRecipientForm(props) {
  const { setFormRef, submitForm, renderFormValidationMessage } = useForm({ protect: true });

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [emailAddress, setEmailAddress] = useState('');

  const handleSubmit = submitForm(async () => {
    if (props.onSubmit) {
      await props.onSubmit(firstName, lastName, emailAddress);
    }
  });

  const handleClose = () => {
    props.onClose();
  };

  return (
    <Panel>
      <Panel.Header>Create Recipient</Panel.Header>
      <Panel.Body>
        <Form ref={setFormRef} noValidate>
          <Form.Group>
            <Form.Label required>First Name</Form.Label>
            <Inputs.Text required placeholder='Please enter first name' description='First Name' value={firstName} onValueChange={setFirstName} />
          </Form.Group>
          <Form.Group>
            <Form.Label required>Last Name</Form.Label>
            <Inputs.Text required placeholder='Plase enter last name' description='Last Name' value={lastName} onValueChange={setLastName} />
          </Form.Group>
          <Form.Group>
            <Form.Label required>Email Address</Form.Label>
            <Inputs.Email required placeholder='Please enter email address' description='Email Address' value={emailAddress} onValueChange={setEmailAddress} />
          </Form.Group>
        </Form>
      </Panel.Body>
      <Panel.Footer>
        {renderFormValidationMessage()}
        <Inputs.Button variant='default' onClick={handleClose} iconClass='icons8-undo' label='Cancel' />
        <Inputs.Button variant='success' onClick={handleSubmit} iconClass='icons8-add-user-male' label='Create' />
      </Panel.Footer>
    </Panel>
  );
}
